export var AppMode;
(function (AppMode) {
    AppMode["OPERATIONS"] = "OPERATIONS";
    AppMode["SECURITY"] = "SECURITY";
    AppMode["NONE"] = "NONE";
})(AppMode || (AppMode = {}));
//# sourceMappingURL=app-mode.js.map